import styled from "styled-components";
import { media } from "../../../../layouts/utils";
import {
  TituloH1 as TituloPrincipal,
  Descricao,
} from "../../../../components/TituloSorriso/styles";

export const Container = styled.div`
  display: flex;
  gap: 20px;
  height: 362px;
  padding: 0 131px 0 131px;
  justify-content: space-between;
  align-items: center;
  background: #d9dcdd;

  @media (max-width: 1050px) {
    padding: 0 50px 0 50px;
  }

  @media (max-width: 767px) {
    height: auto;
    padding: 20px 32px 4px 32px;

    & > img {
      display: none;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 767px) {
    width: 80%;
    gap: 12px;
  }
`;

export const Background = styled.img`
  background-image: cover;
  width: 100%;
  height: 450px;
  object-fit: cover;
  ${media.phone`
    display: flex;
    height: 100%;
    top: 0;
  `}
`;

export const BackgroundImage = styled.img``;

export const TextIntro = styled(Descricao)`
  max-width: 290px;
  font-weight: 500;
  color: ${(props) => props.cor};
  font-size: 20px;
  line-height: 24px;
  text-align: left;

  @media (max-width: 767px) {
    padding: 0;
    margin: 0;
    max-width: 280px;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
  }
`;

export const Title = styled(TituloPrincipal)`
  color: ${(props) => props.cor};
  font-weight: 600;
  font-size: 48px;
  max-width: 560px;
  line-height: 55px;
  padding-top: 0px;
  text-align: left;

  @media (max-width: 1030px) {
    font-size: 40px;
    line-height: 40px;
  }

  @media (max-width: 767px) {
    font-weight: 500;
    font-size: 28px;
    line-height: 33px;
    padding-bottom: 12px;
  }
`;

export const ContainerCTA = styled.div`
  ${media.desktop`
    display: block;
    button {
      width: 100%;
    }
  `}
  display: inline;

  ${media.phone`
    margin-bottom: 20px;
  `}
`;
